import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div className="absolute inset-x-0 top-0 ">
      <div className="px-5 py-4 flex justify-center ">
        <Link to="/">
          <img
            className="h-44 w-full max-w-2xl"
            src="https://upload.wikimedia.org/wikipedia/commons/9/98/International_Pok%C3%A9mon_logo.svg"
            alt="logo pokemon"
          />
        </Link>
      </div>
    </div>
  );
}

export default Header;
